import { useEffect, useState } from "react";
import { Alert, Snackbar } from "@mui/material";

type FavoriteFeedbackEvent = CustomEvent<{ message?: string }>;

/**
 * Favorite add/remove confirmation.
 * Matches the product-page share snackbar: bottom center, light green success panel.
 */
const FavoriteFeedbackPopup = () => {
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleFavoriteFeedback = (event: Event) => {
      const logdetails: string[] = [];
      logdetails.push("action=favorite_feedback");
      const nextMessage = (event as FavoriteFeedbackEvent).detail?.message;
      logdetails.push(`message=${nextMessage || "none"}`);

      if (!nextMessage) {
        logdetails.push("result=ignored");
        console.log("FavoriteFeedbackPopup -> handleFavoriteFeedback ->", logdetails.join(" | "));
        return;
      }

      setMessage(nextMessage);
      setOpen(true);
      logdetails.push("result=shown");
      logdetails.push("position=bottom-center");
      console.log("FavoriteFeedbackPopup -> handleFavoriteFeedback ->", logdetails.join(" | "));
    };

    window.addEventListener("favorite-feedback", handleFavoriteFeedback);
    return () => window.removeEventListener("favorite-feedback", handleFavoriteFeedback);
  }, []);

  return (
    <Snackbar
      open={open}
      autoHideDuration={2500}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert onClose={() => setOpen(false)} severity="success" sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default FavoriteFeedbackPopup;
